export enum TagTypes {
  SOURCE = 'source',
  CAPABILITY = 'capability',
  PRACTICE = 'practice',
  REGION = 'region',
  AUTOMATIONCENTRE = 'automationCentre',
  SCRIPTLIBRARY = 'scriptLibrary',
}
